/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteMetaMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteMetaMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteMetaMcpServerSecurity = {
  option1?: DeleteMetaMcpServerSecurityOption1 | undefined;
  option2?: DeleteMetaMcpServerSecurityOption2 | undefined;
};

export type DeleteMetaMcpServerRequest = {
  /**
   * The ID of the meta MCP server to delete
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteMetaMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteMetaMcpServerSecurityOption1$outboundSchema: z.ZodMiniType<
  DeleteMetaMcpServerSecurityOption1$Outbound,
  DeleteMetaMcpServerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteMetaMcpServerSecurityOption1ToJSON(
  deleteMetaMcpServerSecurityOption1: DeleteMetaMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    DeleteMetaMcpServerSecurityOption1$outboundSchema.parse(
      deleteMetaMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteMetaMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteMetaMcpServerSecurityOption2$outboundSchema: z.ZodMiniType<
  DeleteMetaMcpServerSecurityOption2$Outbound,
  DeleteMetaMcpServerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function deleteMetaMcpServerSecurityOption2ToJSON(
  deleteMetaMcpServerSecurityOption2: DeleteMetaMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    DeleteMetaMcpServerSecurityOption2$outboundSchema.parse(
      deleteMetaMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteMetaMcpServerSecurity$Outbound = {
  Option1?: DeleteMetaMcpServerSecurityOption1$Outbound | undefined;
  Option2?: DeleteMetaMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteMetaMcpServerSecurity$outboundSchema: z.ZodMiniType<
  DeleteMetaMcpServerSecurity$Outbound,
  DeleteMetaMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteMetaMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteMetaMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteMetaMcpServerSecurityToJSON(
  deleteMetaMcpServerSecurity: DeleteMetaMcpServerSecurity,
): string {
  return JSON.stringify(
    DeleteMetaMcpServerSecurity$outboundSchema.parse(
      deleteMetaMcpServerSecurity,
    ),
  );
}

/** @internal */
export type DeleteMetaMcpServerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteMetaMcpServerRequest$outboundSchema: z.ZodMiniType<
  DeleteMetaMcpServerRequest$Outbound,
  DeleteMetaMcpServerRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteMetaMcpServerRequestToJSON(
  deleteMetaMcpServerRequest: DeleteMetaMcpServerRequest,
): string {
  return JSON.stringify(
    DeleteMetaMcpServerRequest$outboundSchema.parse(deleteMetaMcpServerRequest),
  );
}
